import { BadgeCheck } from 'lucide-react'
import { STORE_NAME } from '../config'

const badges = ['ISO 22000', 'HACCP', 'EU Organic', 'Halal', 'Kosher', 'RSPO']

export function CertificationsStrip() {
  return (
    <section className="px-4 py-12 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl rounded-2xl border border-brand-gold/20 bg-brand-gold-subtle p-8 sm:p-10">
        <div className="flex flex-col items-center gap-8 lg:flex-row lg:justify-between">
          <div className="max-w-xl text-center lg:text-left">
            <h2 className="font-display text-xl font-bold text-brand-ink sm:text-2xl">
              Compliance support on every shipment
            </h2>
            <p className="mt-2 text-sm text-brand-slate sm:text-base">
              At {STORE_NAME}, we arrange third-party certification, certificates of analysis and origin
              documents as standard — matched to the import requirements of your market.
            </p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-3">
            {badges.map((b) => (
              <span
                key={b}
                className="inline-flex items-center gap-1.5 rounded-full border border-brand-gold/40 bg-white px-4 py-2 text-sm font-semibold text-brand-navy"
              >
                <BadgeCheck className="h-4 w-4 text-brand-gold" />
                {b}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
